// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-app',
    data: () => ({
        layout: '',
        widthMode: 'default',
    }),
    created() {
        if (!utils.isNullOrEmpty(this.$route.meta.layout)) {
            this.layout = this.$route.meta.layout;
        }
        else {
            this.layout = this.$host.config.layoutName;
        }
        if (!utils.isNullOrEmpty(this.$route.meta.widthMode)) {
            this.widthMode = this.$route.meta.widthMode;
        }
    },
    watch: {
        "$route.meta.layout"(value) {
            if (utils.isNullOrEmpty(value)) {
                this.layout = this.$host.config.layoutName;
            }
            else {
                this.layout = value;
            }
        },
        "$route.meta.widthMode"(value) {
            if (utils.isNullOrEmpty(value)) {
                this.widthMode = 'default';
            }
            else {
                this.widthMode = this.$route.meta.widthMode;
            }
        }
    }
});
// #endregion
